<template>
    <div class="header-main">
      <div class="header-title">
        {{data.form ? data.form.name : '-'}}
        <slot name="btn"></slot>
      </div>
      <div class="header-info">
        <label class="label">受试者信息：</label><label v-if="data.patient"> {{data.patient.patientNum}}/{{data.patient.name || '-'}}</label>
      </div>
      <template v-if="data.form">
        <!--<div class="header-info">-->
          <!--<label class="label">待关闭质疑数：</label>{{data.form.questionCount}}-->
        <!--</div>-->
        <div class="header-info">
          <label class="label">提交人：</label>{{data.form.userRealname}}
        </div>
        <div class="header-info">
          <label class="label">提交时间：</label>{{data.form.submitTime}}
        </div>
      </template>
    </div>
</template>

<script>
  export default {
    name: 'VoiceHeader',
    props:{
      data:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .header-main{
    border-bottom: 1px solid rgba(0,0,0,0.5);
    height: 50px;
    margin-bottom: 20px;
  }
  .header-title{
    font-size: 18px;
    font-weight: bold;
    float: left;
  }
  .header-info{
    float: right;
    margin-right: 10px;
    .label{
      color: rgba(0,0,0,0.5);
    }
  }
</style>